export default __webpack_public_path__ + "static/media/tulabharam.de9b1ab0.svg";